import { gql } from '@apollo/client/core';

export const canIntent = gql`query($userId: String!){
  canIntent(userId: $userId) {
    id
    firstname
    lastname
    userAvatar
  }
}`;

export const canIntentForOrg = gql`query($userId: String!, $orgId: String! ){
  canIntentForOrg(userId: $userId, orgId: $orgId) {
    id
    firstname
    lastname
    organizationId
    organizationName
    organizationAvatar
    organizationType
  }
}`;

export const canIntentForFollowingGroup = gql`query($userId: String!, $followingGroupId: String! ){
  canIntentForFollowingGroup(userId: $userId, followingGroupId: $followingGroupId) {
    id
    firstname
    lastname
    userAvatar
    organizationId
    organizationName
    organizationAvatar
    organizationType
  }
}`;

export const createPaymentIntent = gql`mutation ($userId: String!, $item: PaymentInput! ) {
   createPaymentIntent(userId: $userId, item: $item )
}`;

export const createPaymentIntentForOrg = gql`mutation ($userId: String!,
   $orgId: String!, $item: PaymentInput! ) {
   createPaymentIntentForOrg(userId: $userId, orgId: $orgId, item: $item )
}`;

export const createPaymentIntentForFollowingGroup = gql`mutation ($userId: String!,
   $followingGroupId: String!, $item: PaymentInput!, $orgId: String) {
   createPaymentIntentForFollowingGroup(userId: $userId, followingGroupId: $followingGroupId, item: $item, orgId: $orgId)
}`;

export const benevityCauses = gql`query($q: String!, $page: String! ){
  benevityCauses(q: $q, page: $page) {
    causes {
      id
      name
      logo
      description
    }
  }
}`;

export const benevityCauseDetails = gql`query($causeId: String! ){
  benevityCauseDetails(causeId: $causeId) {
    id
    logo
    name
    description
    attributes {
      name
    }
  }
}`;

export const createStickerPurchaseIntent = gql`mutation ($input: StickerPurchaseInput! ) {
  createStickerPurchaseIntent(input: $input)
}`;

export const canIntentForSticker = gql`query($stickerId: String!){
  canIntentForSticker(stickerId: $stickerId) {
    id
    title
    url
    description
    entity
    entityId
    user {
      id
      firstname
      lastname
    }
    varients {
      id
      stickerId
      title
      cost
      description
      sortOrder
      isActive
    }
    sweepstakesSticker {
      checkoutPageLegal
    }
    published
    tags
    cost
    campaignType
    causes
    nonProfitSuggestions
    maxQuantity
    maxDonation
    donationMultiplier
    impact
    startDate
    endDate
    seen
    isSpotlight
    creatorTitle
    createdAt
  }
}`;

export const validateIntentForSticker = gql`
query($stickerId: String!, $entity: String!, $entityId: String!){
  validateIntentForSticker(stickerId: $stickerId, entity: $entity, entityId: $entityId) {
    id
    isValid
    errors
  }
}`;
export const validateIntentForStickerPublic = gql`
query($stickerId: String!){
  validateIntentForStickerPublic(stickerId: $stickerId) {
    id
    isValid
    errors
  }
}`;

export const createInitiateWalletIntent = gql`mutation ($input: InitiateWalletInput! ) {
  createInitiateWalletIntent(input: $input)
}`;

export const canIntentForWalletPricing = gql`query($walletPricingId: String!){
  canIntentForWalletPricing(walletPricingId: $walletPricingId) {
    id
    cost
    walletType
    employeesRange
    features
    logo
    description
    productId
  }
}`;

export const curatedBenevityMarketPlaceUpgrade = gql`query {
  curatedBenevityMarketPlaceUpgrade {
    id
    cost
    features
    logo
    description
    productId
  }
}`;

export const getPaymentsLog = gql`query {
  getPaymentsLogV2 {
    user {
      id
      firstname
      lastname
      avatar
      email
      phone
    }
    organization {
      id
      name
      avatar
      email
      phone
    }
    benevityTransaction {
      id
      transactionType
      amount
      causeId
      causeName
      meta
    }
    benevityW2WCreditTransaction {
      id
      credits
      notes
      message
      meta
      fromEntity
      toEntity
      fromUser {
        id
        firstname
        lastname
        avatar
        email
        phone
      }
      fromOrganization {
        id
        name
        email
        avatar
        email
        phone
      }
      toUser {
        id
        firstname
        lastname
        avatar
        email
        phone
      }
      toOrganization {
        id
        name
        avatar
        email
        phone
      }
    }
    stickerTransaction {
      id
      stickerId
      causeId
      variantId
      cost
      amount_donated
      amount_rebate
      campaignType
      purchaseType
      benevity_transaction_Id
      stripe_transaction_Id
      orgStripeAccountId
      Org_Payment_stripe_transaction_Id
      transactionMeta
      createdAt
      isProcessed
      transactionMeta
    }
    stripeTransaction {
      id
      intentId
      transactionType
      meta
      amount
      walletDeposit
      fee_Convenience
      fee_CreditCard
      processed
    }
    orgPaymentStripeTransaction {
      id
      intentId
      transactionType
      meta
      amount
      walletDeposit
      fee_Convenience
      fee_CreditCard
      processed
    }
    sticker {
      id
      title
      url
      description
      entity
      entityId
      user {
        id
        firstname
        lastname
        avatar
        email
        phone
      }
      organization {
        id
        name
        email
        avatar
        email
        phone
      }
      published
      tags
      cost
      campaignType
    }
    amount
    paymentType
    paymentInfo
    status
    createdAt
  }
}`;

export const getOrgAdminPaymentsLogV2 = gql`query($entity: String! $entityId: String!){
  getOrgAdminPaymentsLogV2(entity: $entity entityId: $entityId) {
    user {
      id
      firstname
      lastname
      avatar
      email
      phone
    }
    organization {
      id
      name
      avatar
      email
      phone
    }
    benevityTransaction {
      id
      transactionType
      amount
      causeId
      causeName
      meta
    }
    benevityW2WCreditTransaction {
      id
      credits
      notes
      message
      meta
      fromEntity
      toEntity
      fromUser {
        id
        firstname
        lastname
        avatar
        email
        phone
      }
      fromOrganization {
        id
        name
        email
        avatar
        email
        phone
      }
      toUser {
        id
        firstname
        lastname
        avatar
        email
        phone
      }
      toOrganization {
        id
        name
        avatar
        email
        phone
      }
    }
    stickerTransaction {
      id
      stickerId
      causeId
      variantId
      cost
      amount_donated
      amount_rebate
      campaignType
      purchaseType
      benevity_transaction_Id
      stripe_transaction_Id
      orgStripeAccountId
      Org_Payment_stripe_transaction_Id
      transactionMeta
      createdAt
      isProcessed
      transactionMeta
    }
    stripeTransaction {
      id
      intentId
      transactionType
      meta
      amount
      walletDeposit
      fee_Convenience
      fee_CreditCard
      processed
    }
    orgPaymentStripeTransaction {
      id
      intentId
      transactionType
      meta
      amount
      walletDeposit
      fee_Convenience
      fee_CreditCard
      processed
    }
    sticker {
      id
      title
      url
      description
      entity
      entityId
      user {
        id
        firstname
        lastname
        avatar
        email
        phone
      }
      organization {
        id
        name
        email
        avatar
        email
        phone
      }
      published
      tags
      cost
      campaignType
    }
    amount
    paymentType
    paymentInfo
    status
    createdAt
  }
}`;

export const getCouponByPromoCode = gql`query($promotionCode: String!){
  getCouponByPromoCode(promotionCode: $promotionCode) {
    name
    code
    promoCodeId
    couponCodeId
    percent_off
    amount_off
    max_redemptions
    times_redeemed
    livemode
    active
    valid
    applicable_products
  }
}`;

export const createStickerWebIntent = gql`
mutation ($stickerId: String!, $causeId: String!, $cost: String!, $socialShopId: UUID, $glowId: UUID) {
  createStickerWebIntent(
    stickerId: $stickerId,
    causeId: $causeId,
    cost: $cost,
    socialShopId: $socialShopId,
    glowId: $glowId
  )
}`;

export const createStickerWebIntentPublic = gql`
mutation ($stickerId: String!, $causeId: String!, $cost: String!, $socialShopId: UUID, $glowId: UUID) {
  createStickerWebIntentPublic(
    stickerId: $stickerId,
    causeId: $causeId,
    cost: $cost,
    socialShopId: $socialShopId,
    glowId: $glowId
  )
}`;

export const curatedBenevityCauses = gql`query {
  curatedBenevityCauses {
    id
    name
    logo
    description
  }
}`;

export const unclaimedBenevityCauses = gql`query($query: String!, $page: String!) {
  unclaimedBenevityCauses(query: $query, page: $page) {
    causes {
      id
      name
      logo
      description
    }
    pagination {
      nextPage
      lastPage
      currentPage
      totalResults
      pageSize
    }
  }
}`;

export const createAnonymousStickerTransaction = gql`mutation ($intentId: String!, $clientSecret: String!, $email: String!, $phone: String!){
  createAnonymousStickerTransaction(intentId: $intentId, clientSecret: $clientSecret, email: $email, phone: $phone)
}`;

export const purchaseAnonymousPaidSticker = gql`mutation ($intentId: String!, $clientSecret: String!, $email: String!, $phone: String!, $firstName: String!, $lastName: String!, $embedOrganizationId: UUID, $embedHost: String){
  purchaseAnonymousPaidSticker(intentId: $intentId, clientSecret: $clientSecret, email: $email, phone: $phone, firstName: $firstName, lastName: $lastName, embedOrganizationId: $embedOrganizationId, embedHost: $embedHost)
}`;

export const createStickerTicketEmailConfirmation = gql`
  mutation ($descriptions: [StickerTicketEmailDescriptionTypeInput!]!, $email: String!, $name: String!, $intentId: String!, $clientSecret: String!, $userId: String!, $stickerId: String!) {
    createStickerTicketEmailConfirmation(descriptions: $descriptions, email: $email, name: $name, intentId: $intentId, clientSecret: $clientSecret, userId: $userId, stickerId: $stickerId) {
      title
      description
      ticketDescription
      unitPrice
      quantity
      totalAmount,
      email,
      name,
      userId,
      stickerId
    }
  }
`;

// Benevity Wallet Operations
export const benevityDetails = gql`query {
  benevityDetails {
    hasWallet
    amountInWallet
  }
}`;

export const hasBenevityWallet = gql`query($entityId: String!, $entityType: String!) {
  hasBenevityWallet(entityId: $entityId, entityType: $entityType) {
    hasWallet
  }
}`;

export const benevityW2WTransferCredits = gql`query(
  $fromEntityType: String!,
  $fromEntityId: String!,
  $toEntityType: String!,
  $toEntityId: String!,
  $notes: String!,
  $amount: Decimal!,
  $moneyRequestId: String,
  $glowId: UUID
) {
  benevityW2WTransferCredits(
    benevityW2WCreditTransferInput: {
      fromEntityType: $fromEntityType
      fromEntityId: $fromEntityId
      toEntityType: $toEntityType
      toEntityId: $toEntityId
      notes: $notes
      amount: $amount
      moneyRequestId: $moneyRequestId
      glowId: $glowId
    }
  )
}`;

export const makeDonation = gql`mutation(
  $credits: Decimal!,
  $causeId: String!,
  $recurring: String!,
  $notes: String!,
  $glowId: UUID
) {
  makeDonation(
    credits: $credits
    causeId: $causeId
    recurring: $recurring
    notes: $notes
    glowId: $glowId
  )
}`;

export const makeDonationForOrg = gql`mutation(
  $credits: Decimal!,
  $orgId: String!,
  $causeId: String!
) {
  makeDonationForOrg(
    credits: $credits
    orgId: $orgId
    causeId: $causeId
  )
}`;

export const createWebIntent = gql`mutation {
  createWebIntent
}`;

// Wallet Initiation Mutations
export const initiateWallet = gql`mutation {
  initiateWallet
}`;

// Paginated wallet transactions for user
export const benevityTransactions = gql`query($skip: Int!, $take: Int!) {
  benevityTransactions(skip: $skip, take: $take) {
    id
    transactionType
    amount
    notes
    meta
    entity
    causeId
    causeName
    description
    createdAt
    updatedAt
    fromEntityName
    toEntityName
    stickerId
    stickerType
  }
}`;
